import { Component, OnInit } from '@angular/core';
import { ContactService } from './contact-service';
import { Select2OptionData } from 'ng-select2';
import { Options } from 'select2';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

    public singleOption: Options;

    formResponse: boolean;
    formSent: boolean;
    isLoading = false;

    contactFormData: object;
    rolesData = ['Candidat', 'Companie', 'Altele'];

    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    serverErrorMessages = [];

    constructor(private contactService: ContactService,
        private translate: TranslateService) {
    }

    ngOnInit() {
        this.singleOption = {
            width: '100%',
            placeholder: '-- Selectează Opțiune --',
            allowClear: true
        };
    }

    sendContactMessage(form: NgForm) {

        this.isLoading = true;

        this.contactFormData = {
            name: form.value.name,
            email: form.value.email,
            message: form.value.message,
            subject: form.value.subject,
            role: form.value.role,
            status: 'new',
            postingDate: new Date()
        }

        if (form.valid) {
            this.contactService.sendContactForm(this.contactFormData).subscribe(resp => {
                this.formResponse = true;
                this.formSent = true;
                form.resetForm();
                this.isLoading = false;

            }, error => {
                this.formResponse = false;
                this.formSent = true;
                this.isLoading = false;
            })
        } else {
            this.formResponse = false;
            this.formSent = true;
            this.isLoading = false;
        }
    }
}
